import React from 'react';
import { Link } from 'react-router-dom';
import ctaCteLogo from '../assets/ctacte/logoCtaCte.png';
import landingHero from '../assets/ctacte/landing-hero.png';
import './Landing.css';

const benefits = [
  {
    icon: 'fas fa-calendar-check',
    title: 'Día a día ordenado',
    text: 'Registrá cobros, pagos, notas y comprobantes de forma simple, sin convertirlo en una tarea pesada.'
  },
  {
    icon: 'fas fa-file-invoice',
    title: 'Comprobantes a mano',
    text: 'Guardá facturas, recibos y notas para encontrar rápido qué pasó, cuándo pasó y con quién.'
  },
  {
    icon: 'fas fa-chart-line',
    title: 'Saldos claros',
    text: 'Consultá ingresos, salidas y saldos filtrados para entender tu situación sin hacer cuentas aparte.'
  },
  {
    icon: 'fas fa-table',
    title: 'Listados simples',
    text: 'Buscá, filtrá, paginá y exportá tus datos cuando quieras revisar o compartir información.'
  }
];

const workflow = [
  'Creá cuentas y subcuentas con códigos sugeridos.',
  'Cargá movimientos simples o asociados a comprobantes.',
  'Relacioná personas, clientes o proveedores solo cuando te sirva.',
  'Revisá listados y exportá información cuando la necesites.'
];

const contact = {
  name: 'Nicolás Horenstein',
  email: 'ctacte@nhorenstein.com',
  linkedin: 'https://www.linkedin.com/in/nico-horenstein/'
};

const Landing = () => (
  <main className="landing-page">
    <section className="landing-hero" style={{ backgroundImage: `url(${landingHero})` }}>
      <div className="landing-hero-overlay" />
      <header className="landing-nav">
        <Link to="/" className="landing-brand" aria-label="CtaCte App">
          <img src={ctaCteLogo} alt="CtaCte App" />
          <span>CtaCte App</span>
        </Link>
        <Link to="/login" className="landing-login-link">
          <i className="fas fa-arrow-right-to-bracket" />
          Ingresar
        </Link>
      </header>

      <div className="landing-hero-content">
        <p className="landing-kicker">Cuenta corriente para ordenar tu día a día</p>
        <h1>CtaCte App</h1>
        <p className="landing-hero-copy">
          Organizá movimientos, comprobantes, cuentas, clientes o proveedores en una experiencia simple, pensada para el uso diario de cada uno.
        </p>
        <div className="landing-hero-actions">
          <Link to="/login" className="landing-primary-action">
            Ingresar
            <i className="fas fa-arrow-right" />
          </Link>
          <a href="#beneficios" className="landing-secondary-action">
            Ver beneficios
          </a>
        </div>
        <div className="landing-hero-contact" aria-label="Contacto">
          <span>{contact.name}</span>
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
          <a href={contact.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
        </div>
      </div>
    </section>

    <section id="beneficios" className="landing-section landing-benefits">
      <div className="landing-section-heading">
        <span>Uso cotidiano</span>
        <h2>Menos vueltas para saber dónde estás parado</h2>
        <p>La app concentra el registro, el seguimiento y la consulta en pantallas claras para ordenar cobros, pagos y comprobantes sin complicarte.</p>
      </div>
      <div className="landing-benefit-grid">
        {benefits.map((benefit) => (
          <article className="landing-benefit-card" key={benefit.title}>
            <div className="landing-benefit-icon">
              <i className={benefit.icon} />
            </div>
            <h3>{benefit.title}</h3>
            <p>{benefit.text}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="landing-section landing-workflow">
      <div className="landing-workflow-copy">
        <span>Flujo simple</span>
        <h2>De la carga a la consulta, sin pasos innecesarios</h2>
        <p>
          Cada operación puede quedar tan simple como la necesitás: un movimiento con fecha y nota, o una carga más completa con comprobante, cuenta y persona relacionada.
        </p>
      </div>
      <div className="landing-workflow-list">
        {workflow.map((item, index) => (
          <div className="landing-workflow-item" key={item}>
            <strong>{String(index + 1).padStart(2, '0')}</strong>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </section>

    <section className="landing-section landing-reporting">
      <div>
        <span>Control personal</span>
        <h2>Reportes y exportaciones para revisar tu información cuando quieras</h2>
        <p>
          Las grillas filtrables, los saldos calculados y las exportaciones a Excel o PDF te ayudan a revisar, compartir o guardar tu información sin preparar archivos manuales.
        </p>
      </div>
      <Link to="/login" className="landing-primary-action compact">
        Ingresar al sistema
        <i className="fas fa-arrow-right" />
      </Link>
    </section>

    <section className="landing-section landing-contact">
      <div>
        <span>Contacto</span>
        <h2>¿Querés escribir por CtaCte App?</h2>
        <p>
          Podés contactar directamente a {contact.name} por mail o LinkedIn.
        </p>
      </div>
      <div className="landing-contact-actions">
        <a href={`mailto:${contact.email}`} className="landing-contact-link">
          <i className="fas fa-envelope" />
          {contact.email}
        </a>
        <a href={contact.linkedin} target="_blank" rel="noreferrer" className="landing-contact-link linkedin">
          <i className="fab fa-linkedin" />
          LinkedIn
        </a>
      </div>
    </section>

    <footer className="landing-footer">
      <div>
        <strong>CtaCte App</strong>
        <span>{contact.name}</span>
      </div>
      <nav aria-label="Contacto de Nicolás Horenstein">
        <a href={`mailto:${contact.email}`}>{contact.email}</a>
        <a href={contact.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
      </nav>
    </footer>
  </main>
);

export default Landing;
